import { LineRecord } from '../interfaces/LineRecord';

export const calculateLineTotalCostPrice = (line: LineRecord): number => {
  const hasReceivedQuantity = line.quantity !== undefined && line.quantity !== '';
  const hasReceivedUom = line.originalUom !== '';
  const quantity = hasReceivedQuantity || hasReceivedUom
    ? Number(line.quantity ?? 0)
    : line.expectedQuantity ?? 0;

  return (line.unitCostPrice ?? 0) * (Number.isFinite(quantity) ? quantity : 0);
};

export const calculateTotalCostPrice = (lines: LineRecord[]): number =>
  lines.reduce((total, line) => total + calculateLineTotalCostPrice(line), 0);
